import { Badge, HStack, Spacer, Text } from '@chakra-ui/react'
import { range } from 'lodash'

import { User } from '../icon'

type Props = {
  joinMemberCount: number
}

export const VideoCallingBadge: React.FC<Props> = ({ joinMemberCount }) => {
  const userCount = joinMemberCount <= 3 ? joinMemberCount : 3
  const plusCount = joinMemberCount - userCount
  return (
    <Badge bg="orange.500" color="white" px="2" py="0.5" borderRadius="sm">
      <HStack spacing="1" fontSize="12px">
        <span>現在ビデオ通話中</span>
        <Spacer />
        {range(userCount).map(i => (
          <User key={i} size="14px" />
        ))}
        {plusCount > 0 && (
          <Text fontSize="14px" p={0} m={0}>
            +{plusCount}
          </Text>
        )}
      </HStack>
    </Badge>
  )
}
